import { dataResponse, errorCodeResponse, errorResponse } from './utils/response-templates.js';
import { documentConversionStatusSchema } from './documents.js';
import { ErrorCodes } from './error-codes.js';
import { z } from './utils/zod.js';
export const uploadDocxForConversionRequestSchema = z.object({
    file: z.instanceof(File),
});
export const docxConversionDtoSchema = z.object({
    id: z.string(),
    filename: z.string(),
    status: documentConversionStatusSchema,
});
export const uploadDocxForConversionResponseSchema = dataResponse(docxConversionDtoSchema);
export const docxConversionStatusResponseSchema = dataResponse(z.object({
    status: documentConversionStatusSchema,
    filename: z.string(),
}));
export const docxConversionNotFoundResponseSchema = errorCodeResponse(ErrorCodes.EDocumentNotFound, 'Conversion not found');
export const docxConversionInvalidFileResponseSchema = errorResponse('Only DOCX files are allowed');
export const docxConversionNotReadyResponseSchema = errorCodeResponse(ErrorCodes.EDocumentNotReady, 'Conversion is not ready for download');
export const docxConversionRateLimitResponseSchema = errorCodeResponse(ErrorCodes.EDocxConversionRateLimitReached, 'Daily DOCX conversion limit reached');
